module.exports = __webpack_public_path__ + "assets/images/glassShade-04.1f1c5778dbc5444e3fe74619c6eb5011.svg";